<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h2>Extrato Financeiro</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="8">
        <p>Estes valores são referentes à <strong>porcentagem da Easytick</strong> em cada venda online.<br> O valor é líquido, ou seja, já desconta o valor do Organizador e da Gerencianet.</p>

        <h4 class="mb-4">Saldo: <b-badge>{{ balance | currency }}</b-badge></h4>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-3"
        ></b-pagination>

        <b-table striped hover show-empty
          :items="statements"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          responsive="md"
        >

          <template v-slot:cell(transaction)="data">
            <span v-if="!data.item.event">{{ data.item.description }}</span>
            <span v-else>{{ data.item.description + " - " + data.item.event + " - Compra " + data.item.order }}</span>
          </template>
        </b-table>
      </b-col>

      <b-col lg="4">
        <h3>Registrar movimentação</h3>

        <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
          @dismissed="feedback.show=false">
            {{ feedback.data }}
        </b-alert>

        <b-form @submit.prevent="executeStatement">
          <b-form-group
            label="Valor:"
            description="Exemplo: R$ 300,00">
            <b-input-group prepend="R$">
                <money required class="form-control" v-model="form.value" v-bind="money"></money>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="Descrição:"
            description="Exemplo: Depósito da tarifa de transferência do evento Festa Social">
            <b-form-input v-model="form.description" type="text" />
          </b-form-group>
          <b-form-group label="Tipo">
            <b-form-radio-group id="radios2" v-model="selected" name="radioSubComponent">
              <b-form-radio value="withdraw">Saque</b-form-radio>
              <b-form-radio value="deposit">Depósito</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-button type="submit" variant="primary" class="float-right mb-4">Registrar</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { Money } from 'v-money'

export default {
  name: 'FinancialStatements',
  components: {
    Money
  },
  data () {
    return {
      statements: [],
      balance: 0,
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'transaction', label: 'Transação' },
        { key: 'value', label: 'Valor', formatter: this.$options.filters.currency, tdClass: 'valueCell' },
        { key: 'created_at', label: 'Data', formatter: this.$options.filters.date }
      ],
      selected: '',
      form: {
        value: '',
        description: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2
      },
      feedback: {
        data: '',
        type: '',
        show: false
      },
      currentPage: 1,
      perPage: 15,
      totalRows: 1
    }
  },
  async mounted () {
    await this.getStatements()
  },
  methods: {
    async getStatements () {
      const url = process.env.VUE_APP_URL_APP + '/b/financial/statements?limit=100'
      try {
        const resp = await this.$http.get(url)
        this.statements = resp.body.statements
        this.balance = resp.body.balance
        this.totalRows = this.statements.length
      } catch (e) {
        console.error(e)
      }
    },
    refresh () {
      this.getStatements()
    },
    executeStatement () {
      if (this.selected === '') {
        this.feedback.data = 'Selecione o tipo da operação: Saque ou Depósito?'
        this.feedback.type = 'danger'
        this.feedback.show = true
        return
      }
      const url = process.env.VUE_APP_URL_APP + '/b/financial/statements/' + this.selected
      const p = {
        value: Math.round(this.form.value * 100),
        description: this.form.description
      }
      this.$http.post(url, p).then(
        res => {
          this.getStatements()
          this.form.value = ''
          this.form.description = ''
          this.selected = ''
          this.feedback.data = 'Executado com sucesso!'
          this.feedback.type = 'success'
          this.feedback.show = true
        },
        err => {
          this.feedback.data = err.body.message
          this.feedback.type = 'danger'
          this.feedback.show = true
          console.log(err)
        }
      )
    },
    valueCell (value, key, item) {
      if (value > 0) {
        return 'text-success'
      }
      return 'text-danger'
    }
  }
}
</script>
